export const FormActions = {

    completeForm(formId, info=null, self=null) {
        let entityInfo;
        self = self ?? this;
        try {
            entityInfo = Object.assign(self.read(), info);

            const form = $(`form#${formId}`);

            for (const [key, value] of Object.entries(entityInfo)) {

                const field = form.find(`[name=${key}]`);

                if (!field.length) continue;

                else {
                    for (let element of field) {
                        if(element.tagName == 'SELECT') {
                            const findedOption = $(element).find(`option[value="${value}"]`);
                            if (!findedOption.length){
                                const customOption = field.find(`option.custom-option`);
                                customOption.removeClass('.d-none');
                                customOption.val(value);
                                customOption.text(value);
                            }
                            field.val(value);
                        }
                        else if (element.type == 'checkbox'){
                            if (element.value == value) {
                                $(element).attr('checked', true);
                            }
                        }
                        else if (element.tagName != 'DIV') element.value = value;
                        else element.innerText = value;
                    }
                }
            }

            return entityInfo;
        } catch {
            return {};
        }

    },

    collectDataInForm(formId) {
        let data = {};
        let inputs = $(`#${formId} input:not([type=checkbox]), #${formId} textarea, #${formId} select`);

        for (let input of inputs) {
            input = $(input);
            data[input.attr('name')] = input.val();
        }
        return data;
    },

}
